import React from 'react';
import { Link } from 'react-router-dom';
interface HeaderProps {
  onOpenDemo: () => void;
}
export function Header({
  onOpenDemo
}: HeaderProps) {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-midnight-navy/95 backdrop-blur-sm border-b border-white/10 px-6 py-4" data-id="element-77">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-78">
        <div className="flex items-center gap-12" data-id="element-79">
          <Link to="/" data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/2PmeGfc8FfeehVwkDn5EB7/ChatGPT_Image_Jul_7,_2026,_03_43_37_PM.png" alt="ROI Logo" className="h-14 w-auto object-contain" data-id="element-81" />
          </Link>
          <nav className="hidden md:flex items-center gap-8" data-id="element-82">
            {[{
            name: 'Platform',
            href: '/platform'
          }, {
            name: 'Solutions',
            href: '/solutions'
          }, {
            name: 'Why ROI',
            href: '/why-roi'
          }, {
            name: 'Resources',
            href: '/resources'
          }].map(link => <Link key={link.name} to={link.href} className="text-stark-white/80 hover:text-stark-white text-sm font-medium transition-colors" data-id="element-83">
                {link.name}
              </Link>)}
          </nav>
        </div>
        <button onClick={onOpenDemo} className="bg-accent-red text-stark-white px-6 py-2 rounded-full text-sm font-bold hover:bg-red-700 transition-all shadow-lg shadow-accent-red/20" data-id="element-84">
          Book a Demo
        </button>
      </div>
    </header>;
}